import { render, staticRenderFns } from "./V2CartErrorPopup.vue?vue&type=template&id=06aeb9f6&scoped=true&"
import script from "./V2CartErrorPopup.vue?vue&type=script&lang=js&"
export * from "./V2CartErrorPopup.vue?vue&type=script&lang=js&"
import style0 from "./V2CartErrorPopup.vue?vue&type=style&index=0&id=06aeb9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aeb9f6",
  null
  
)

export default component.exports